/**
 * Feature Flags Service Singleton
 *
 * Provides a singleton instance of FeatureFlagsService for use throughout the app.
 * This allows feature flag fetching from places like Pinia stores where Vue's
 * inject() is not available.
 *
 * Uses lazy initialization to avoid circular dependency issues with axios/router.
 */

import type { AxiosInstance } from 'axios'
import { FeatureFlagsService } from '@erebus/feature-flags'

let _instance: FeatureFlagsService | null = null

/**
 * Initialize the feature flags service with an axios instance.
 * Must be called before getFeatureFlagsService().
 */
export function initFeatureFlagsService(axios: AxiosInstance): void {
  if (!_instance) {
    _instance = new FeatureFlagsService(axios)
  }
}

/**
 * Get the singleton instance of FeatureFlagsService.
 * Throws if initFeatureFlagsService() hasn't been called.
 */
export function getFeatureFlagsService(): FeatureFlagsService {
  if (!_instance) {
    throw new Error('FeatureFlagsService not initialized. Call initFeatureFlagsService() first.')
  }
  return _instance
}
